import $ from 'jquery';

class BjzmScripts {
	
	constructor() {
		
	}

	doAllScripts() {
		this.isHamburgerOpen = false;
		this.do_hamburger();
		this.doVimeo();
		this.doTouchScreenFunctions();
		this.doMap();
		this.doAjaxGform();
		if ($('.news-page__filter').length) {
			this.activateNewsFilter();
		}

		console.log('hello!');
	}

	activateNewsFilter() {
		// toggling category filter
		$('.news-page__filter__category__main').on('click',function(){
			$(this).siblings().slideToggle('fast');
			$(this).toggleClass('active');
		});
		// clicking category filter
		var defaultCatText = $('.news-page__filter__category__main span').text();
		$('.news-page__filter__category__list span').on('click',function(){
			if (!$(this).hasClass('active')) {
				var catID = $(this).data('cat');
				var catName = $(this).text();
				$('.news-page__filter__category__main span').text(catName);
				$(this).addClass('active').siblings().removeClass('active');
				searchPosts();
			} else {
				$(this).removeClass('active');
				$('.news-page__filter__category__main span').text(defaultCatText);
				searchPosts();
			}
			$('.news-page__filter__category__main').removeClass('active');
			$('.news-page__filter__category__list').slideUp();
		});
		// using the text filter
		$('.news-page__filter__text input').on('keyup input change',function(e){			
			var val = $(this).val();
			var parent = $(this).parent();
			if (val != '') {
				parent.addClass('filled');
			} else {
				parent.removeClass('filled');
			}
			if (e.which==13) {
				searchPosts();
			}
		});
		// clicking the text filter go button
		$('.news-page__filter__text__go').on('click',function(e){
			e.preventDefault();
			searchPosts();
		});
		// main search function
		function searchPosts() {
			console.log('searching posts...');
			var results = $('.news-page__results');
			var defaultPosts = $('.news-page__loop');
			var pagination = $('.pagination');

			var textSearch = $('.news-page__filter__text input').val();
			var catSearch = $('.news-page__filter__category__list span.active');
			var catID = catSearch.length ? catSearch.data('cat') : false;

			if (textSearch == '' && catID == '-1') { // no filters present
				results.hide();
				defaultPosts.show();
				pagination.show();
			} else {				
				var textS = textSearch != "" ? textSearch : false;
				var endpoint = "/wp-json/wp/v2/news_post?filter[orderby]=date&order=desc&per_page=100&_embed";
				if (catID && catID != '-1') {
					endpoint += "&news_category="+catID;
				}
				if (textS) {
					endpoint += "&search="+textS;
				}
				console.log('submitting to '+endpoint);
				$.get( endpoint, function( data ) {
                    console.log('posts found:',data);
                    results.empty();
                    if (data.length) {
                    	console.log('posts populating...');
                    	$.each(data,function(index,item){
                    		var link = item.acf.publication_url;
                    		var title = item.title.rendered;
                    		var hasEmbed = typeof item._embedded !== 'undefined';
                    		var hasMedia = hasEmbed ? typeof item._embedded['wp:featuredmedia'] !== 'undefined' : false;                    		
                    		var image = hasMedia ? item._embedded['wp:featuredmedia']['0'].source_url : false;
                    		var imageAlt = hasMedia ? item._embedded['wp:featuredmedia']['0'].alt_text : '';
                    		var source = item.acf.publication_title;
                    		var date = item.acf.publication_date;
                    		var dateFormat = new Date(Date.parse(date));
                    		var dd = dateFormat.getDate();
							var mm = dateFormat.getMonth()+1; 
							var yyyy = dateFormat.getFullYear();
							var dateString = dd+'/'+mm+'/'+yyyy;
                    		results.append('<div class="news-post">'+(image ? '<a href="'+link+'" target="_blank" class="news-post__image"><img src="'+image+'" alt="'+imageAlt+'"></a>' : '')+'<h4 class="news-post__head">'+source+'<span>- </span>'+dateString+'</h4><h3 class="news-post__title"><a class="news-post__link touch-screen" href="'+link+'" target="_blank">'+title+'</a></h3></div>');
                    	});
                    } else {
                    	console.log('no posts found...');
                    	results.append('<h2 style="padding:0 15px">No results found</h2>');
                    }
                    pagination.hide();
                    defaultPosts.hide();
                    results.show();
                });
			}
		}
	}

	doAjaxGform() {
	

/*		(function (SHFormLoader, $) {
			$.get( BJZM_DATA.ajaxurl + '?action=gf_button_get_form&form_id=1',function(response){
				$('#gf_button_form_container_1').html(response).fadeIn();
			});
		}(window.SHFormLoader = window.SHFormLoader || {}, jQuery));

*/	}

	doMap() {
		if (document.getElementById('map-canvas')){

		    var lat = $(".am_single_map").data('lat');
		    var lng = $(".am_single_map").data('lng');

		    // Coordinates to center the map
		    // var myLatlng = new google.maps.LatLng(43.707276,-79.399562);
		    var myLatlng = new google.maps.LatLng(lat,lng);

		    // Other options for the map, pretty much selfexplanatory
		    var mapOptions = {
		        zoom: 16,
		        center: myLatlng,
		        mapTypeId: google.maps.MapTypeId.ROADMAP,
		        styles: [{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#f5f5f5"}]},{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#47d7ac"},{"saturation":"70"},{"lightness":"43"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"visibility":"on"}]},{"featureType":"poi.attraction","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#47d7ac"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"off"},{"color":"#ff0000"}]},{"featureType":"poi.place_of_worship","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"hue":"#00ffff"},{"saturation":-60},{"lightness":23},{"visibility":"on"}]},{"featureType":"poi.school","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"hue":"#ffffff"},{"saturation":-100},{"lightness":100},{"visibility":"on"}]},{"featureType":"road","elementType":"labels","stylers":[{"hue":"#bbbbbb"},{"saturation":-100},{"lightness":26},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"saturation":100},{"lightness":-22},{"visibility":"on"},{"color":"#fae053"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"saturation":100},{"lightness":-35},{"visibility":"simplified"},{"color":"#fae053"}]},{"featureType":"road.arterial","elementType":"labels.text","stylers":[{"color":"#a3a3a3"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#63666a"}]},{"featureType":"road.arterial","elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#a7a8a9"}]},{"featureType":"road.local","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"saturation":55},{"lightness":-6},{"visibility":"on"},{"color":"#00587c"}]},{"featureType":"water","elementType":"labels","stylers":[{"hue":"#7fc8ed"},{"saturation":55},{"lightness":-6},{"visibility":"off"}]}],
		    };
		 
		    // Attach a map to the DOM Element, with the defined settings
		    var map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

		    let riocanPosition = {lat: lat,lng: lng};
		    let customMarker = '/wp-content/themes/bjzm-starter-theme/assets/img/RioCanDropPin.svg';
		    var marker = new google.maps.Marker({
				position: riocanPosition,
				map: map,
				title: 'RioCan',
				icon: customMarker
			});


		}

	}

	doVimeo() {

		if( $(".vimeobox").length < 1 )
			return false;

		var play = document.getElementById('play');
		let vimeoUrl = "<div class='embed-container'> <iframe style='display:block;' src='https://player.vimeo.com/video/359367600?autoplay=1' class='video'></iframe></div>";

		play.onclick = function() {
			
	        setTimeout(function(){

	    		$('.vimeobox__img').fadeOut();
	    		$('.responsive-iframe').append(vimeoUrl);

	        }, 1000);

		}
	}

	do_hamburger() {
		var self = this;
		$(".hamburger__inner").off('click').on('click',function(e){
			e.preventDefault();
			console.log('click');
			if( $("body").hasClass("navigation--active") ) {
				console.log('close it');
				self.closeMobileMenu();
			}
			else {
				console.log('open it');
				self.openMobileMenu();
			}
		})
	}

	openMobileMenu() {
		$("body").addClass("navigation--active");
		this.isHamburgerOpen = true;
	}

	closeMobileMenu() {
		$("body").removeClass("navigation--active");
		this.isHamburgerOpen = false;
	}

	activeNavigation() {

		$(".navigation__link")
		    .click(function(e) {
		        var link = $(this);

		        var item = link.parent(".current-menu-item");
		        
		        if (item.hasClass("active")) {
		            item.removeClass("active").children("a").removeClass("active");
		        } else {
		            item.addClass("active").children("a").addClass("active");
		        }

		        if (item.children("ul").length > 0) {
		            var href = link.attr("href");
		            link.attr("href", "#");
		            setTimeout(function () { 
		                link.attr("href", href);
		            }, 300);
		            e.preventDefault();
		        }
		    })
		    .each(function() {
		        var link = $(this);
		        if (link.get(0).href === location.href) {
		            link.addClass("active").parents(".current-menu-item").addClass("active");
		            return false;
		        }
		    });
	}

	doTouchScreenFunctions() {
			var DoTouchScreenClasses = {

			is_touch_device: function() {
				return (('ontouchstart' in window)
					|| (navigator.MaxTouchPoints > 0)
					|| (navigator.msMaxTouchPoints > 0));
			},

			getTouchClass: function() {
				return ( this.is_touch_device() ) ? ' touch-screen' : ' desktop-screen';
			},

			setTouchScreenClasses(selectors) {
				var classes = this.getTouchClass();
				$(selectors).addClass( classes );
			}

		}

		DoTouchScreenClasses.setTouchScreenClasses(".button, .register-gallery__link, .news-post__link, .news-post__phone, .news-post__mail, .contact__link,.navigation__link, .property-profile__data-value");

		$(document).on('gform_post_render', (e, form_id) => {
			DoTouchScreenClasses.setTouchScreenClasses(".button");
		});

	}
	
}

export default new BjzmScripts;




